/* eslint-disable import/no-unresolved */

import { css } from 'styled-components';

const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);

const makeResponsive = (key, i) =>
	key && i
		? css`
				${key}: ${typeof i === 'string' ? i : i.xs || null};
				${i.sm &&
				`@media (min-width: 576px) {
        ${key}: ${i.sm};
      }`}
				${i.md &&
				`@media (min-width: 768px) {
        ${key}: ${i.md};
      }`}
    ${i.lg &&
				`@media (min-width: 992px) {
        ${key}: ${i.lg};
      }`}
    ${i.xl &&
				`@media (min-width: 1200px) {
        ${key}: ${i.xl};
      }`}
		  `
		: '';

const findDirection = (key, i) => {
	if (typeof (i.x || i.y || i.b || i.t || i.l || i.r) === 'undefined') {
		return makeResponsive(`${key}`, i);
	}
	return css`
		${typeof i.x !== 'undefined' && makeResponsive(`${key}-left`, i.x)}
		${typeof i.x !== 'undefined' && makeResponsive(`${key}-right`, i.x)}
    ${typeof i.y !== 'undefined' && makeResponsive(`${key}-top`, i.y)}
    ${typeof i.y !== 'undefined' && makeResponsive(`${key}-bottom`, i.y)}
    ${typeof i.t !== 'undefined' && makeResponsive(`${key}-top`, i.t)}
    ${typeof i.l !== 'undefined' && makeResponsive(`${key}-left`, i.l)}
    ${typeof i.r !== 'undefined' && makeResponsive(`${key}-right`, i.r)}
    ${typeof i.b !== 'undefined' && makeResponsive(`${key}-bottom`, i.b)}
	`;
};

const findRoundedDirection = (i, themeRadius) => css`
	${typeof (i.b || i.t || i.l || i.r || i.tl || i.tr || i.bl || i.br) === 'undefined' &&
	typeof i === 'string' &&
	makeResponsive('border-radius', themeRadius[i])}
	${typeof (i.b || i.t || i.l || i.r || i.tl || i.tr || i.bl || i.br) === 'undefined' &&
	i.xs &&
	makeResponsive('border-radius', { xs: themeRadius[i.xs] })}
  ${typeof (i.b || i.t || i.l || i.r || i.tl || i.tr || i.bl || i.br) === 'undefined' &&
	i.sm &&
	makeResponsive('border-radius', { sm: themeRadius[i.sm] })}
  ${typeof (i.b || i.t || i.l || i.r || i.tl || i.tr || i.bl || i.br) === 'undefined' &&
	i.md &&
	makeResponsive('border-radius', { md: themeRadius[i.md] })}
  ${typeof (i.b || i.t || i.l || i.r || i.tl || i.tr || i.bl || i.br) === 'undefined' &&
	i.lg &&
	makeResponsive('border-radius', { lg: themeRadius[i.lg] })}
  ${typeof (i.b || i.t || i.l || i.r || i.tl || i.tr || i.bl || i.br) === 'undefined' &&
	i.xl &&
	makeResponsive('border-radius', { xl: themeRadius[i.xl] })}
  ${typeof i.t !== 'undefined' && makeResponsive('border-top-left-radius', themeRadius[i.l])}
  ${typeof i.t !== 'undefined' && makeResponsive('border-top-right-radius', themeRadius[i.r])}
  ${typeof i.l !== 'undefined' && makeResponsive('border-top-left-radius', themeRadius[i.l])}
  ${typeof i.l !== 'undefined' && makeResponsive('border-bottom-left-radius', themeRadius[i.l])}
  ${typeof i.b !== 'undefined' && makeResponsive('border-bottom-left-radius', themeRadius[i.l])}
  ${typeof i.b !== 'undefined' && makeResponsive('border-bottom-right-radius', themeRadius[i.r])}
  ${typeof i.r !== 'undefined' && makeResponsive('border-top-right-radius', themeRadius[i.r])}
  ${typeof i.r !== 'undefined' && makeResponsive('border-bottom-right-radius', themeRadius[i.r])}
  ${typeof i.tl !== 'undefined' && makeResponsive('border-top-left-radius', themeRadius[i.tl])}
  ${typeof i.tr !== 'undefined' && makeResponsive('border-top-right-radius', themeRadius[i.tr])}
  ${typeof i.bl !== 'undefined' && makeResponsive('border-bottom-left-radius', themeRadius[i.bl])}
  ${typeof i.br !== 'undefined' && makeResponsive('border-bottom-right-radius', themeRadius[i.br])}
`;

const makeResponsiveFontSize = (i, textSize) => css`
	${typeof i === 'string'
		? `font-size: ${textSize.size[i]}; line-height:${textSize.height[i]};`
		: i.xs && `font-size: ${textSize.size[i.xs]}; line-height:${textSize.height[i.xs]};`}
	${i.sm &&
	`@media (min-width: 576px) {
      font-size: ${textSize.size[i.sm]}; line-height:${textSize.height[i.sm]};
    }`}
  ${i.md &&
	`@media (min-width: 768px) {
      font-size: ${textSize.size[i.md]}; line-height:${textSize.height[i.md]};
    }`}
  ${i.lg &&
	`@media (min-width: 992px) {
      font-size: ${textSize.size[i.lg]}; line-height:${textSize.height[i.lg]};
    }`}
  ${i.xl &&
	`@media (min-width: 1200px) {
      font-size: ${textSize.size[i.xl]}; line-height:${textSize.height[i.xl]};
    }`}
`;

const makeResponsiveProperty = (i, property, themeValues) => css`
	${typeof i === 'string' || typeof i === 'number'
		? `${property}: ${themeValues[i]};`
		: i.xs && `${property}: ${themeValues[i.xs]};`}
	${i.sm &&
	`@media (min-width: 576px) {
      ${property}: ${themeValues[i.sm]}};
    }`}
  ${i.md &&
	`@media (min-width: 768px) {
      ${property}: ${themeValues[i.md]}};
    }`}
  ${i.lg &&
	`@media (min-width: 992px) {
      ${property}: ${themeValues[i.lg]}};
    }`}
  ${i.xl &&
	`@media (min-width: 1200px) {
      ${property}: ${themeValues[i.xl]}};
    }`}
`;

const makeResponsiveShadow = (i, themeShadow) => css`
	${typeof i === 'string' || typeof i === 'number'
		? `box-Shadow: ${themeShadow[i]};`
		: i.xs && `box-Shadow: ${themeShadow[i.xs]};`}

	${i.sm &&
	`@media (min-width: 576px) {
        box-Shadow: ${themeShadow[i.sm]}};
      }`}

    ${i.md &&
	`@media (min-width: 768px) {
        box-Shadow: ${themeShadow[i.md]}};
      }`}

    ${i.lg &&
	`@media (min-width: 992px) {
        box-Shadow: ${themeShadow[i.lg]}};
      }`}

    ${i.xl &&
	`@media (min-width: 1200px) {
        box-Shadow: ${themeShadow[i.xl]}};
      }`}
`;

export const functions = {
	range,
	findDirection,
	makeResponsive,
	findRoundedDirection,
	makeResponsiveFontSize,
	makeResponsiveShadow,
	makeResponsiveProperty,
};
